var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"space-select--option"},[_c('WMCheckbox',{attrs:{"value":_vm.selected,"size":"small","label":_vm.space.name},on:{"input":function($event){return _vm.$emit('change', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }